export default "__VITE_ASSET__B0wNZO9n__"